<template lang="pug">
md-dialog(:md-active.sync='show')
    md-dialog-title
        span(style="float:left;color: #012C58") Ask The Expert
        md-button.md-icon-button(@click.native="$emit('update:show', false)" style="float:right;padding-bottom: 16px;")
          md-icon(style="color: #012C58") close
    md-dialog-content
        .md-layout.md-gutter
            .md-layout-item.md-aligment-top-center.md-size-100(style="text-align:justify")
              | Wanneer uw paard een tekort heeft aan energie, kunnen verschillende factoren aan de oorsprong liggen.   
              | Misschien krijgt uw paard niet voldoende voer binnen. Maar het kan ook zijn dat er een onderliggend probleem is.
              |
              | Contacteer onze experten voor advies op maat van uw paard
            .md-layout-item.md-alignment-top-space-between.md-size-80.md-small-size-100.md-xsmall-size-100
                md-field(style='width: 100%;height:100%')
                  label {{$t('label.yourMessage')}}
                  md-textarea(type='text' v-model='message' maxlength='512' style="height:100%")
            .md-layout-item.md-alignment-top-center.md-size-20.md-small-size-100.md-xsmall-size-100(style="padding: 4px;margin:auto")
                img(src="/static/img/logo_cavalor.png" style="height:150px;display:block;margin:auto")
                div(style="padding: 8px;text-align:center;font-size:16px;font-weight:bold") Consumer Line
                div(style="text-align:center") {{$t('label.atyourservice')}}
                div(style="text-align:center") + 32 (0)9 220 25 25
    md-dialog-actions
        md-button.md-primary.md-raised(@click.native='send', style='float:right') {{$t('email.send')}}
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: ['show', 'ration', 'step'],
  data () {
    return {
      message: ''
    }
  },
  computed: {
    ...mapState({
      contact: state => state.activecampaign.contact,
      tags: state => state.activecampaign.tags
    }),
    ...mapState([
      'user',
      'horse'
    ]),
    ...mapGetters([
      'breedType',
      'breed',
      'weight',
      'phaseType',
      'phase',
      'activityType',
      'activity',
      'materials',
      'krachtvoer',
      'ruwvoer',
      'supplement'
    ])
  },
  methods: {
    async tag () {
      const { id = undefined } = this.contact || {}
      // add concern tag to contact id
      await this.$store.dispatch('activecampaign/addTag', { contactTag: { contact: id, tag: 109 } })
    },
    async send () {
      // append user and state identification to message
      let line = '\n' + '-'.repeat(80) + '\n'
      line += this.$t('label.eigenaar') + ': ' + this.user.name + '\n'
      line += this.$t('label.email') + ': ' + this.user.email + '\n'
      line += this.$t('label.phone') + ': ' + this.user.phone + '\n'
      line += this.$t('label.paard') + ': ' + this.horse.name + '\n'
      line += this.$t('label.ras') + ': ' + this.breed.name + '\n'
      switch (this.step) {
        case 1:
          line += 'AskTheExpert: ' + this.$t('label.gewicht') + '\n'
          break
        case 2:
          line += this.$t('label.gewicht') + ': ' + this.weight.name + '\n'
          line += this.$t('label.phase') + ': ' + this.phaseType.name + ' / ' + this.phase.name + '\n'
          line += 'AskTheExpert: ' + this.$t('label.unavailable') + '\n'
          break
        case 3:
          line += this.$t('label.gewicht') + ': ' + this.weight.name + '\n'
          line += this.$t('label.phase') + ': ' + this.phaseType.name + ' / ' + this.phase.name + '\n'
          line += this.$t('label.activity') + ': ' + this.activityType.name + ' / ' + this.activity.name + '\n'
          line += 'AskTheExpert: ' + this.$t('label.advice') + '\n'
          break
      }
      const finalMessage = this.message + line
      let data = { email: this.user.email, subject: 'Ask the Expert', message: finalMessage }
      if (this.step > 2) {
        this.ration.mailPDF(data)
      } else {
        this.$store.dispatch('askTheExpert', data)
      }
      this.tag()
      this.$emit('update:show', false)
    }
  }
}
</script>
<style scoped>
.md-dialog {
    min-width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/AskLowEnergy.vue